import React, { useState } from "react";
import EmojiThrower from "../EmojiThrower/EmojiThrower";
import useGetThrowablesAndEmojis from "@/src/hooks/data/useGetThrowablesAndEmojis";
import { useThrowables } from "@/src/hooks/data/useGameTable";
import { EMOJI_SIZE } from "@/Poker/data/Constants";

const EmojiThrowManager = ({ tempTableId }) => {
  const { getThrowableEmojiById } = useGetThrowablesAndEmojis();
  const throwables = useThrowables(tempTableId);
  return throwables?.map(
    ({
      uid,
      throwableId,
      sourceCoordinates,
      targetCoordinates,
      duration,
      loop,
    }) => (
      <EmojiThrower
        key={uid}
        animationSource={getThrowableEmojiById(throwableId)}
        from={sourceCoordinates}
        to={targetCoordinates}
        duration={duration}
        size={EMOJI_SIZE}
        loop={loop}
      />
    )
  );
};

export default EmojiThrowManager;
